import BaseListStore from 'stores/base/BaseListStore'

import Script, { IScriptCreatePayload } from './Script'

class ScriptStore extends BaseListStore<Script, IScriptCreatePayload> {
  constructor() {
    super(Script, { idbTableName: 'scripts' })
  }
}

export default new ScriptStore()
